export default __webpack_public_path__ + "static/media/audio.c1bd802c.svg";